var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWasher = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M30.038 32.414c0 .6-.488 1.085-1.087 1.085H10.586a1.086 1.086 0 0 1-1.087-1.085V8.586c0-.6.487-1.086 1.086-1.086h18.366c.6 0 1.087.487 1.087 1.085v23.83Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M26.467 22.017h.91a.26.26 0 0 1 .262.261v3.107a.26.26 0 0 1-.261.261h-.907"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M19.769 30.773c3.866 0 7-3.108 7-6.941 0-3.834-3.134-6.942-7-6.942s-7 3.108-7 6.942 3.134 6.94 7 6.94Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M19.769 28.925c2.835 0 5.133-2.28 5.133-5.094 0-2.813-2.298-5.094-5.133-5.094s-5.133 2.281-5.133 5.094 2.298 5.094 5.133 5.094Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M17.085 23.746a2.894 2.894 0 0 1 2.9-2.887M9.366 14.486h20.672M11.185 12.285h5.482V9.719H11.18zM26.746 11.875a.5.5 0 0 1 .999 0 .498.498 0 1 1-.999 0ZM23.728 11.875a.5.5 0 1 1 1 .002.5.5 0 0 1-1-.002Z"
}))));
export default SvgWasher;